"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBProductPayrollPositive = function SvgBProductPayrollPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M28.264 55.407a2.512 2.512 0 01-2.511-2.512v-8.983a2.512 2.512 0 015.023 0v8.983a2.512 2.512 0 01-2.512 2.512z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M28.264 43.3a9.787 9.787 0 01-6.697-2.612 2.512 2.512 0 113.44-3.658 4.864 4.864 0 003.299 1.247c2.445 0 4.437-1.674 4.437-3.75 0-2.227-2.336-3.575-4.646-3.768a11.98 11.98 0 01-3.274-.695c-3.683-1.49-5.977-4.58-5.977-8.062 0-4.89 4.244-8.825 9.46-8.825 2.44-.016 4.8.88 6.614 2.512a2.512 2.512 0 11-3.349 3.718 4.806 4.806 0 00-3.24-1.198c-2.453 0-4.437 1.675-4.437 3.751 0 2.076 2.168 3.181 2.838 3.45a7.326 7.326 0 001.808.35c5.359.445 9.252 4.128 9.252 8.767-.067 4.822-4.304 8.774-9.528 8.774z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M28.256 56.512C12.65 56.512 0 43.862 0 28.256 0 12.65 12.65 0 28.256 0a2.512 2.512 0 012.511 2.512v10.465a2.512 2.512 0 01-5.023 0v-7.82C13.465 6.481 4.368 17.181 5.037 29.513 5.705 41.846 15.906 51.5 28.256 51.488A23.233 23.233 0 0039.064 7.686a2.513 2.513 0 012.344-4.446C52.92 9.285 58.82 22.406 55.703 35.029c-3.117 12.623-14.445 21.49-27.447 21.483zM129.34 143.523H18.678a6.488 6.488 0 01-6.48-6.48V117.3a2.512 2.512 0 015.023 0v19.742c0 .804.653 1.457 1.457 1.457H129.34a9.368 9.368 0 009.36-9.36v-59.3a2.512 2.512 0 115.024 0v59.3c-.01 7.94-6.444 14.374-14.384 14.383z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M14.71 80.205a2.512 2.512 0 01-2.512-2.512V58.086a6.488 6.488 0 016.48-6.48H102.4a2.512 2.512 0 110 5.023H18.68c-.805 0-1.458.652-1.458 1.457v19.607a2.512 2.512 0 01-2.511 2.512z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M129.307 56.629H28.842a2.512 2.512 0 110-5.023h100.465a9.402 9.402 0 000-18.804H66.14a2.512 2.512 0 010-5.023h63.209c7.967 0 14.425 6.458 14.425 14.425 0 7.966-6.458 14.425-14.425 14.425h-.042zM38.436 108H18.678a6.488 6.488 0 01-6.48-6.48V77.953a2.512 2.512 0 015.023 0v23.525a1.457 1.457 0 001.457 1.499h19.758a5.442 5.442 0 005.434-5.442 5.367 5.367 0 00-1.59-3.851 5.433 5.433 0 00-3.844-1.591H26.581a2.512 2.512 0 010-5.023h11.855c5.78 0 10.465 4.685 10.465 10.465S44.216 108 38.436 108z",
    fill: "#285"
  })));
};

var _default = SvgBProductPayrollPositive;
exports["default"] = _default;